<script>
	import { Users, Radio, Book, Shield, Heart } from 'lucide-svelte';
	import Modal from '$lib/components/Modal.svelte';

	let showMembershipModal = false;
	let showDonationModal = false;
</script>

<div class="container mx-auto px-4 py-8">
	<h1 class="mb-8 text-4xl font-bold text-blue-800 dark:text-blue-400">Join Our Community</h1>

	<div class="prose prose-lg dark:prose-invert mb-12 max-w-none">
		<p class="text-lg leading-relaxed">
			The Do Something Amateur Radio Club is more than just a club – it's a community of passionate
			individuals dedicated to the art and science of amateur radio. Whether you're a seasoned
			operator or just getting started, your membership helps us build a stronger, more connected
			community.
		</p>
	</div>

	<div class="mb-12 grid gap-8 md:grid-cols-2">
		<div class="rounded-lg bg-white p-6 shadow-lg dark:bg-gray-800">
			<h2 class="mb-4 flex items-center text-2xl font-semibold text-blue-700 dark:text-blue-400">
				<Users class="mr-2 h-6 w-6" />
				Why Become a Member?
			</h2>
			<ul class="space-y-4">
				<li class="flex items-start">
					<Radio class="mt-1 mr-2 h-5 w-5 text-blue-600 dark:text-blue-400" />
					<span>Access to hands-on workshops, technical training, and expert guest speakers</span>
				</li>
				<li class="flex items-start">
					<Book class="mt-1 mr-2 h-5 w-5 text-blue-600 dark:text-blue-400" />
					<span>Participate in field days, contests, and social events with fellow enthusiasts</span
					>
				</li>
				<li class="flex items-start">
					<Shield class="mt-1 mr-2 h-5 w-5 text-blue-600 dark:text-blue-400" />
					<span>Support emergency communications and community preparedness initiatives</span>
				</li>
			</ul>
			<div class="mt-6">
				<button
					class="w-full rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white transition-colors hover:bg-blue-700"
					on:click={() => (showMembershipModal = true)}
				>
					Become a Member
				</button>
			</div>
		</div>

		<div class="rounded-lg bg-white p-6 shadow-lg dark:bg-gray-800">
			<h2 class="mb-4 flex items-center text-2xl font-semibold text-blue-700 dark:text-blue-400">
				<Heart class="mr-2 h-6 w-6" />
				Support Our Mission
			</h2>
			<p class="mb-4">
				Not ready for membership but want to support our community initiatives? Your donation helps
				us:
			</p>
			<ul class="mb-6 space-y-4">
				<li>Foster youth engagement in amateur radio</li>
				<li>Maintain emergency communication equipment</li>
				<li>Organize educational events and workshops</li>
				<li>Support community outreach programs</li>
			</ul>
			<button
				class="w-full rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white transition-colors hover:bg-blue-700"
				on:click={() => (showDonationModal = true)}
			>
				Make a Donation
			</button>
		</div>
	</div>

	<div class="mb-12 rounded-lg bg-blue-50 p-8 dark:bg-blue-900/20">
		<h2 class="mb-4 text-2xl font-semibold text-blue-800 dark:text-blue-400">Your Impact</h2>
		<p class="mb-4 text-lg">
			By joining DSARC, you're not just becoming a member – you're investing in:
		</p>
		<div class="grid gap-6 md:grid-cols-2">
			<div>
				<h3 class="mb-2 text-lg font-semibold text-blue-700 dark:text-blue-300">
					Community Growth
				</h3>
				<p>
					Support mentorship programs and help nurture the next generation of amateur radio
					operators.
				</p>
			</div>
			<div>
				<h3 class="mb-2 text-lg font-semibold text-blue-700 dark:text-blue-300">
					Emergency Preparedness
				</h3>
				<p>
					Strengthen our community's resilience through improved emergency communication
					capabilities.
				</p>
			</div>
			<div>
				<h3 class="mb-2 text-lg font-semibold text-blue-700 dark:text-blue-300">
					Technical Excellence
				</h3>
				<p>Access resources and training to enhance your radio knowledge and operational skills.</p>
			</div>
			<div>
				<h3 class="mb-2 text-lg font-semibold text-blue-700 dark:text-blue-300">
					Social Connection
				</h3>
				<p>Join a vibrant community of like-minded individuals who share your passion for radio.</p>
			</div>
		</div>
	</div>
</div>

<Modal bind:showModal={showMembershipModal} title="Become a Member" noScroll={true}>
	<div class="h-full w-full">
		<iframe
			title="Membership form powered by Zeffy"
			class="h-full min-h-[calc(100vh-12rem)] w-full"
			src="https://www.zeffy.com/embed/ticketing/46985406-4d97-478c-a945-b06715b516d2"
			allowTransparency
		></iframe>
	</div>
</Modal>

<Modal bind:showModal={showDonationModal} title="Make a Donation" noScroll={true}>
	<div class="h-full w-full">
		<iframe
			title="Donation form powered by Zeffy"
			class="h-full min-h-[calc(100vh-12rem)] w-full"
			src="https://www.zeffy.com/embed/donation-form/c7d04f20-a7c0-49b0-8fc8-4ec4f5120b57"
			allowTransparency
		></iframe>
	</div>
</Modal>
